/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @constructor
 */
export let RedeemField = function ($, config, library) {

  const CURRENCY_CONVERSION_FEE = 0.0185;
  const CURRENCY_CONVERSION_FEE_MIN = 1.11;

  /**
   * @type {string}
   */
  let template = `
<div class="slp-redeem-field">
    <input  type="number" class="slp-redeem-field-input" value="{{appliedPoints}}" data-loyalty="input">
    <button type="button" class="slp-redeem-field-button" data-loyalty="apply">`+ config.getPopupText().btnApply+`</button>
    <button type="button" class="slp-redeem-field-button negative" data-loyalty="reset">`+ config.getPopupText().btnReset+`</button>
</div>`;

  /**
   * @type {HTMLElement}
   */
  let redeemElement;

  /**
   * @type {int}
   */
  let appliedPoints = parseInt(library.getCookie(config.getCookieNames().applied)) || 0;

  /**
   * @type {number}
   */
  let rate = config.getRedeemRate();

  /**
   *
   */
  const globalCart = Spurit.global.cartPool.getAdapter(library.appName);

  /**
   * @return {number}
   */
  const getCartDataTotal = () => {
    return globalCart.getPriceTotal();
  };

  /**
   *
   */
  let init = () => {
    const isSubtotalEnough = checkMinSubtotal();
    if (!isSubtotalEnough) {
      this.removeDiscount();
      return;
    }

    makeHtml();
    setHtmlBehaviour();

    if (config.customization().onFieldReady(this)) {
      this.show();
    }
  };

  /**
   * @return {boolean}
   */
  let checkMinSubtotal = () => {
    if (!config.settings().shop.spendLimit.min_subtotal_active) {
      return true;
    }

    let minSubtotal = parseInt(config.settings().shop.spendLimit.min_subtotal);
    return !minSubtotal || getCartDataTotal() >= minSubtotal;
  };

  /**
   *
   */
  let makeHtml = () => {
    redeemElement = document.createElement('div');
    redeemElement.className = 'slp-redeem-field-wrapper';
    redeemElement.style.display = 'none';
    redeemElement.innerHTML = library.mustache().render(
        config.customization().fieldTemplate || template,
        {
          appliedPoints: appliedPoints || '',
          pointsName: config.getPointNames().plural
        }
    );
    library.appendElement(
        config.getRedeemSelector().selector,
        redeemElement,
        config.getRedeemSelector().position
    );
  };

  /**
   * @param {int} amount
   * @return {int}
   */
  let checkPointsAmount = (amount) => {
    amount = parseInt(amount);
    if (isNaN(amount)) {
      return 0;
    }

    let balance = parseInt(config.getCustomer().balance);
    if (!balance) {
      return 0;
    }

    if (amount > balance) {
      amount = balance;
    }

    const maxPointsAmount = Math.floor(this.getMaxPriceOrig() / rate);
    if (amount > maxPointsAmount) {
      amount = maxPointsAmount;
    }

    return amount > 0 ? amount : 0;
  };

  /**
   * @return {number}
   */
  this.getMaxPriceOrig = () => {
    const maxPointsPart = config.getMaxPointsPart();

    const appDiscount = globalCart.getDiscounts().find(d => d.appName === library.appName);
    const appDiscountValue = appDiscount ? appDiscount.value : 0;

    const totalPriceOrig = this.getTotalPriceOrig(appDiscountValue);

    return totalPriceOrig * maxPointsPart / 100;
  };

  /**
   * @param {number} appDiscountValue
   * @return {number}
   */
  this.getTotalPriceOrig = (appDiscountValue) => {
    let totalPriceOrig = this.getDiscountedTotalOrig() + appDiscountValue;

    if (!Spurit.global.prices.isCurrentCurrencyEqualShopCurrency()) {
      const fee = this.getCurrencyConversionFee(totalPriceOrig);
      totalPriceOrig = totalPriceOrig > fee ? totalPriceOrig - fee : 0;
    }

    return totalPriceOrig;
  };

  /**
   * @param {number} totalPriceOrig
   * @return {number}
   */
  this.getCurrencyConversionFee = (totalPriceOrig) => {
    const minFee = CURRENCY_CONVERSION_FEE_MIN * globalCart.getItems().length;
    const fee = totalPriceOrig * CURRENCY_CONVERSION_FEE;

    return fee > minFee ? fee : minFee;
  };

  /**
   *
   */
  let setHtmlBehaviour = () => {
    let inputPoints = redeemElement.querySelector('[data-loyalty="input"]');
    let buttonApply = redeemElement.querySelector('[data-loyalty="apply"]');
    let buttonReset = redeemElement.querySelector('[data-loyalty="reset"]');
    let discountCheckout = this.getDiscountCheckout();

    if (!appliedPoints) {
      $(buttonReset).hide();
    }

    inputPoints.value = checkPointsAmount(library.getCookie(config.getCookieNames().applied) || 1000000000);
    if (!!discountCheckout) {
      globalCart.addFixedDiscount(discountCheckout);
      config.customization().onTotalRecalculated(this);
    }

    library.addEventListener(inputPoints, 'keypress', (e) => {
      if (!(48 <= e.charCode && e.charCode <= 57)) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        return false;
      }
    });

    library.addEventListener(inputPoints, 'change keyup', () => {
      let amount = checkPointsAmount(inputPoints.value);
      if (inputPoints.value !== amount) {
        inputPoints.value = amount;
      }
    });

    library.addEventListener(buttonApply, 'click', () => {
      let val = parseInt(inputPoints.value);
      if ((val && val !== appliedPoints) || (!val && appliedPoints)) {
        this.setAppliedPoints(val);
        if (val) {
          globalCart.addFixedDiscount(this.getDiscountCheckout());
        } else {
          this.removeDiscount();
        }

        appliedPoints ? $(buttonReset).show() : $(buttonReset).hide();
        config.customization().onTotalRecalculated(this);
      }
    });

    library.addEventListener(buttonReset, 'click', () => {
      this.setAppliedPoints(0);
      this.removeDiscount();
      $(buttonReset).hide();
      config.customization().onTotalRecalculated(this);
    });

    globalCart.onChange(function() {
      inputPoints.value = checkPointsAmount(library.getCookie(config.getCookieNames().applied) || 1000000000);

      if (!checkMinSubtotal()) {
        this.removeDiscount();
        $(redeemElement).remove();
      }
    });
  };

  /**
   * @return {int}
   */
  this.appliedPoints = () => appliedPoints;

  /**
   * @param points
   * @return {*}
   */
  this.setAppliedPoints = points => {
    appliedPoints = points;
    library.setCookie(config.getCookieNames().applied, points.toString());
  };

  /**
   *
   */
  this.show = function () {
    $(redeemElement).show();
    config.customization().onFieldShown(this);
  };

  /**
   *
   */
  this.hide = function () {
    $(redeemElement).hide();
  };

  /**
   * @return {{container: HTMLElement}}
   */
  this.getDomElements = function () {
    return {container: redeemElement};
  };

  /**
   * @return {number}
   */
  this.getCurrentDiscount = function () {
    return appliedPoints * rate;
  };

  /**
   * @return {number}
   */
  this.getDiscountCheckout = function () {
    const discount = this.getCurrentDiscount();
    const totalCartPrice = this.getPriceTotalOrig();

    return (discount < totalCartPrice) ? discount : totalCartPrice;
  };

  /**
   *
   */
  this.removeDiscount = () => {
    library.deleteCookie(config.getCookieNames().applied);
    globalCart.removeDiscount();
  };

  this.getPriceTotalOrig = () => {
    return Spurit.global.prices.convertFromCartCurrencyToShop(globalCart.getPriceTotal());
  };

  this.getDiscountedTotalOrig = () => {
    return Spurit.global.prices.convertFromCartCurrencyToShop(globalCart.getDiscountedTotal());
  };

  let isWidgetPlaced = () => {
    return document.getElementsByClassName('slp-redeem-field-wrapper').length !== 0;
  }

  init();

  globalCart.onChange(function() {
    if (!isWidgetPlaced()) {
      init();
    }
  });
};
